import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { Button, Form, FormItem, Switch, Text, Textarea } from "../../../../../components/base";
import { useUser } from "../../../../../libs/hooks/useUser";
import { useAppDispatch } from "../../../../../redux/app/hooks";
import { showAlertToast } from "../../../../../redux/features/app/appSlice";
import { AlertType } from "../../../../../libs/models/AlertType";
import { UserPrompt } from "../../../../../libs/models/users/UsersState";


export const ChatPromptSetting: React.FC = ({ }) => {
  
    const [userPrompt, setUserPrompt] = useState<UserPrompt>({});

    const user = useUser();
    const dispatch = useAppDispatch();

    useEffect(()=>{
      user.getUserPrompt()
      .then((prompt)=>{
        setUserPrompt(prompt);
      }).catch(()=>{
        dispatch(showAlertToast({
          altMessage: "설정을 불러오는데 오류가 발생했어요. 잠시 후 다시 시도해주세요.",
          altType: AlertType.Info,
        }))
      })
    },[]);

    const onSetting = (event: ChangeEvent<HTMLInputElement|HTMLTextAreaElement>) => {
      switch (event.target.id){
        case 'useUserPattern':
          setUserPrompt({...userPrompt, useUserUsagePattern: !userPrompt.useUserUsagePattern});
          break;
        case 'useJob':
          setUserPrompt({ ...userPrompt, useJob: !userPrompt.useJob})
          break;
        case 'prompt':
          setUserPrompt({ ...userPrompt, prompt: event.target.value})
          break;
        case 'nickName':
          setUserPrompt({ ...userPrompt, nickName: event.target.value})
          break;
        default: break;
      }
    }

    const savePrompt = async(event: FormEvent) => {
      event.preventDefault();
      const result = await user.updateUserPrompt(userPrompt);
        if(result) {
          dispatch(showAlertToast({
            altMessage: "저장되었어요.",
            altType: AlertType.Info,
          }))
          //setIsOpen(false);
        }else{
          dispatch(showAlertToast({
            altMessage: "저장이 실패했어요. 잠시 후 다시 시도해주세요.",
            altType: AlertType.Info,
          }))
        }
    }

    
    return (
      <Form variant="vertical" className='personal-setting-form' onSubmit={(event)=>{void savePrompt(event);}}>
        <FormItem label='호칭'>
            <Textarea 
              id='nickName' 
              rows={1} 
              maxRows={1} 
              variant="filled" 
              value={userPrompt.nickName} 
              onChange={onSetting}
              maxLength={10}
              size='large'
            />
        </FormItem>
        <FormItem label='직무 참고하기'
          info={ 
            <div className="dsx-side-right">
              <Switch  id='useJob' onChange={onSetting} checked={userPrompt.useJob}/>
            </div>}
        >
        <Text size='body3' accent='alternative'>
              Works AI가 응답할 때 내 직무를 참고하도록 합니다.
          </Text>               
        </FormItem>
        <FormItem label='채팅 기록 참고' 
          info={<div className="dsx-side-right">
            <Switch id='useUserPattern' onChange={onSetting} checked={userPrompt.useUserUsagePattern}/>
          </div>}
          >
          <Text size='body3' accent='alternative'>
              Works AI가 응답할 때 최근 대화를 참고하도록 합니다.
          </Text>
        </FormItem>
        <FormItem label='Works AI가 대답할 때 고려해야 할 내용을 작성해 주세요'>
          <Textarea 
            variant="filled" 
            showCount
            value={userPrompt.prompt}
            onChange={onSetting}
            id='prompt'
            size='large'
            rows={4}
          />
        </FormItem>
        <div className="dsx-side-right">
          <Button type="submit" variant="primary" size="large"> 저장 </Button>
        </div>
        
      </Form>
    );
  };